export function formatNumberCompact(value: number) {
  return Intl.NumberFormat(undefined, {
    notation: 'compact',
  }).format(value);
}
